export interface PlanningPasteRow {
  code: string;
  quantity: number;
  dueDate: string | null;
  raw: string;
}

export interface PlanningPasteResult {
  rows: PlanningPasteRow[];
  invalidLines: string[];
}

/** Türkçe ondalık (1.234,56 veya 8,5). Geçersiz veya sıfırdan küçükse null. */
export function parseDecimalTR(value: string): number | null {
  const trimmed = value.trim();
  if (!trimmed) return null;
  let cleaned = trimmed;
  const lastComma = cleaned.lastIndexOf(',');
  const lastDot = cleaned.lastIndexOf('.');
  if (lastComma > lastDot) {
    cleaned = cleaned.replace(/\./g, '').replace(',', '.');
  } else if (lastDot > lastComma) {
    cleaned = cleaned.replace(/,/g, '');
  } else if (lastComma !== -1) {
    cleaned = cleaned.replace(',', '.');
  }
  const parsed = Number(cleaned);
  if (!Number.isFinite(parsed) || parsed <= 0) return null;
  return Math.round(parsed * 1_000_000) / 1_000_000;
}

/** dd.MM.yyyy veya yyyy-MM-dd. Geçerliyse yyyy-MM-dd döner. */
export function parsePlanningDate(value: string): string | null {
  const trimmed = value.trim();
  if (!trimmed) return null;
  const turkish = /^(\d{1,2})\.(\d{1,2})\.(\d{4})$/.exec(trimmed);
  if (turkish) {
    const day = Number(turkish[1]);
    const month = Number(turkish[2]);
    const year = Number(turkish[3]);
    return calendarDate(year, month, day);
  }
  const iso = /^(\d{4})-(\d{2})-(\d{2})/.exec(trimmed);
  if (!iso) return null;
  return calendarDate(Number(iso[1]), Number(iso[2]), Number(iso[3]));
}

function calendarDate(year: number, month: number, day: number): string | null {
  if (month < 1 || month > 12 || day < 1 || day > 31) return null;
  const date = new Date(year, month - 1, day);
  if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) return null;
  return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
}

/**
 * Excel'den kopyalanan satır: StokKoduVeyaBarkod<TAB>Miktar[<TAB>Tarih]
 */
export function parsePlanningPaste(text: string): PlanningPasteResult {
  const rows: PlanningPasteRow[] = [];
  const invalidLines: string[] = [];
  for (const rawLine of text.split(/\r?\n/)) {
    const line = rawLine.trim();
    if (!line) continue;
    const parts = line.split('\t');
    if (parts.length < 2) {
      invalidLines.push(line);
      continue;
    }
    const code = parts[0].trim();
    const quantity = parseDecimalTR(parts[1] ?? '');
    if (!code || quantity == null) {
      invalidLines.push(line);
      continue;
    }
    let dueDate: string | null = null;
    if (parts.length >= 3 && parts[2].trim()) {
      dueDate = parsePlanningDate(parts[2]);
      if (!dueDate) {
        invalidLines.push(line);
        continue;
      }
    }
    rows.push({ code, quantity, dueDate, raw: line });
  }
  return { rows, invalidLines };
}
